module.exports = {
    "collectionLabel": `\u{C81C}\u{C548}`
};


//# sourceMappingURL=ko-KR.main.js.map
